import { Badge, Button, Divider, Modal } from 'antd';
import AccountingDetail from './AccountingDetail';
import PriceChangeTable from './PriceChangeTable';
const ProjectAccountingModal = ({
  projectId,
  hideModal,
  isVisible
}) => {
  const handleClose = () => {
    hideModal();
  };
  return <Modal title={`Project ${projectId}`} visible={isVisible} width={800} footer={[<Button key="close" type="primary" onClick={handleClose} data-testid="accounting-close-button">
          Close
        </Button>]}>
      <Badge.Ribbon text="GTI Internal ONLY" color="red">
        <AccountingDetail projectId={projectId} />
      </Badge.Ribbon>
      <Divider plain />
      <PriceChangeTable projectId={projectId} />
    </Modal>;
};
export default ProjectAccountingModal;